import { ContentBlocks } from "../../blocks"
import { PageHeader } from "../../pageHeader"
import { Img } from "../../../layout/Img"
import { Badge } from "../../../layout/Badge"
import { SidebarProfiles } from "../../sidebarProfiles"

const SponsorClient = ({ sponsor }) => {
  const [sponsorLogo] = sponsor.sponsorLogo
  return (
    <div className="">
      <h2 className="block mt-4 mb-2 text-lg font-light leading-tight uppercase text-primary">Partner</h2>
      <Img image={sponsorLogo} className="mt-4 w-60" />
    </div>
  )
}

export const CaseStudies = ({ entry }) => {
  const {
    caseStudyState,
    authorProfile,
    caseStudyCategories,
    caseStudyProgramsAndProducts,
    contentBlocks,
  } = entry
  const [caseStudyCategory] = caseStudyCategories
  const [caseStudyProgramProduct] = caseStudyProgramsAndProducts
  const [sponsor] = entry.sponsor
  return (
    <>
      <PageHeader
        title={entry?.sponsor[0]?.title}
        pageHeaderText={entry?.title}
        pageHeaderImage={entry?.coverPicture}
        caseStudy
      />

      <div className="container px-4 mx-auto my-10 md:w-9/12">
        <div className="flex flex-col gap-10">
          <div className="flex flex-col items-start justify-start gap-2 md:flex-row md:gap-4">
            {caseStudyState && (
              <Badge className="text-secondary bg-highlightColor">
                {caseStudyState}
              </Badge>
            )}
            {caseStudyCategory?.title && (
              <Badge className="text-white bg-primary hover:bg-primary">
                {caseStudyCategory.title}
              </Badge>
            )}
            {caseStudyProgramProduct?.title && (
              <Badge className="text-white bg-pink hover:bg-pink">
                {caseStudyProgramProduct.title}
              </Badge>
            )}
          </div>
          <div className="flex flex-col gap-10 lg:flex-row">
            <div className="w-full md:6/12">
              <div className="flex flex-col gap-10">
                <SponsorClient sponsor={sponsor} />
                {entry?.excerpt && (
                  <div>
                    <h2 className="block mt-4 mb-2 text-lg font-light leading-tight uppercase text-primary">Background</h2>
                    <p className="mt-4 text-lg md:text-xl text-secondary">
                      {entry.excerpt}
                    </p>
                  </div>
                )}
              </div>
            </div>

            <div className="w-12/12 md:w-6/12">
              <SidebarProfiles profiles={authorProfile} />
            </div>
          </div>
        </div>
      </div>

      {contentBlocks?.length > 0 && <ContentBlocks blocks={contentBlocks} />}
    </>
  )
}
